module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc30-fa3f1b16520ab55399b1815dca3c1866.jpg";